import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { Platform } from 'react-native';

// Run web sign-in through the site's own domain (horsemath.app/__/auth/handler,
// served by Firebase Hosting) instead of firebaseapp.com. A cross-domain handler
// breaks redirect sign-in in browsers that partition third-party storage
// (Safari, Firefox, newer Chrome) — it fails silently back to the login page.
// Flip to true ONLY after https://horsemath.app/__/auth/handler is an authorized
// redirect URI on the Google OAuth web client AND a return URL on the Apple
// Services ID (com.gbr.herdmanager.web); otherwise Google/Apple sign-in breaks.
const AUTH_ON_OWN_DOMAIN = true;
const OWN_AUTH_DOMAINS = ['horsemath.app'];
const webHost = typeof window !== 'undefined' && window.location ? window.location.hostname : '';

const firebaseConfig = {
  apiKey: 'AIzaSyCOkkTFIaXnncEVal9Eu_q2oaMGV17hx2E',
  authDomain: AUTH_ON_OWN_DOMAIN && Platform.OS === 'web' && OWN_AUTH_DOMAINS.includes(webHost)
    ? webHost
    : 'horse-breeding-tracker.firebaseapp.com',
  projectId: 'horse-breeding-tracker',
  storageBucket: 'horse-breeding-tracker.firebasestorage.app',
  messagingSenderId: '711734326364',
  appId: '1:711734326364:web:3bc9827ffab7a36fbe2299',
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let auth = null;
export let firebaseInitError = null;

try {
  if (Platform.OS === 'web') {
    const fbAuth = require('firebase/auth');
    try {
      auth = fbAuth.initializeAuth(app, {
        persistence: fbAuth.browserLocalPersistence,
        popupRedirectResolver: fbAuth.browserPopupRedirectResolver,
      });
    } catch {
      auth = fbAuth.getAuth(app);
    }
  } else {
    const rnAuth = require('@firebase/auth/dist/rn/index.js');
    const AsyncStorage = require('@react-native-async-storage/async-storage').default;
    try {
      auth = rnAuth.initializeAuth(app, {
        persistence: rnAuth.getReactNativePersistence(AsyncStorage),
      });
    } catch {
      auth = rnAuth.getAuth(app);
    }
  }
} catch (e) {
  firebaseInitError = e.message + '\n' + e.stack;
}

export { auth };
export const db = getFirestore(app);
export default app;
